<template>
  <Modal v-model="openForm" footer-hide :width="1080" :fullscreen="false">
    <Button type="primary" @click="printFocus"> 打印</Button>
    <div id="print">
      <div v-for="(item, index) in forms" :key="index" class="printcontainer">
        <h2>{{ $store.state.nowActiveTitle }}</h2>
        <Form ref="item" :label-width="100" style="border: solid 2px #333">
          <Row :gutter="16">
            <Col
              :span="y.span ? y.span : 8"
              v-for="(y, index1) in col"
              :key="index1"
              style="border: solid 1px #999"
            >
              <FormItem :label="y.title" style="margin-bottom: 4px"
                ><template v-if="y.show == 'photo'">
                  <img
                    style="width: 32.33%; margin: 2px"
                    v-for="m in item[y.key]"
                    :key="m"
                    :src="axios.platConfig.fileUri + m"
                  /> </template
                ><template v-else>
                  {{ item[y.key] }}
                </template></FormItem
              >
            </Col>
            <Col span="24">
              <FormItem label="领导签字" style="margin-bottom: 4px"
                ><table class="printtable">
                  <thead>
                    <tr>
                      <td v-for="(x, index) in columns" :key="index">
                        {{ x.title }}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(y, index) in item.qianzi" :key="index">
                      <td v-for="(x, index) in columns" :key="index">
                        {{
                          x.type == "yymmdd"
                            ? utils.time(y[x.key], x.type)
                            : y[x.key]
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
    <!--悬浮在右下角的打印按钮-->
  </Modal>
</template>
<script>
export default {
  //https://blog.csdn.net/weixin_43865196/article/details/126616516
  data() {
    return {
      width: document.documentElement.clientWidth - 10,
      openForm: false,
      param: this.$route.query,

      forms: {},
      columns: [
        {
          title: "职务",
          key: "job",
        },
        {
          title: "姓名",
          key: "name",
        },
        {
          title: "时间",
          key: "time",
          type: "yymmdd",
        },
        {
          title: "签字意见",
          key: "opinion",
        },
      ],
      col: [],
    };
  },
  created() {
    this.init();
    window.addEventListener("beforeprint", () => {
      // 打印开始时触发
      this.loading = true;
    });

    window.addEventListener("afterprint", () => {
      // 打印结束是触发
      this.loading = false;
    });
  },
  methods: {
    reach(v, c) {
      this.forms = v;
      var a = JSON.parse(JSON.stringify(c));
      a.splice(0, 1);
      this.col = a;
      //this.openForm = true;
      this.printFocus();
    },
    async init() {
      // 初始化数据
    },
    // 按钮触发打印
    ratingReport() {
      const printHTML = document.querySelector("#print").innerHTML;
      // 将打印的区域赋值，进行打印
      window.document.body.innerHTML = printHTML;

      window.print(); // 调用window打印方法

      window.location.reload(); // 打印完成后重新加载页面
    },

    printFocus() {
      // 打印事件
      // 1. 挂载要打印的内容

      setTimeout(() => {
        // 延迟，等待 Dialog 渲染在 DOM 树上
        // 2. 隐藏要打印的内容
        const container = document.getElementById("print");
        this.openForm = false;
        // 3. 创建 iframeconst
        var iframe = document.createElement("iframe");
        const printContent = container.innerHTML;
        iframe.setAttribute(
          "style",
          "position: absolute; width: 0; height: 0;"
        );
        document.body.appendChild(iframe);
        const doc = iframe.contentWindow.document;
        // 4. 写入内容//
        doc.write('<style media="print">@page {size: landscape;}</style>');
        doc.write(
          `<link href="static/css/print.css" rel="stylesheet" /><link href="static/css/iview.css" rel="stylesheet" />`
        );
        doc.write("<div>" + printContent + "</div>");
        const link = doc.getElementsByTagName("link")[1];
        link.onload = () => {
          // 样式文件加载完毕后打印
          // 5. 执行打印
          iframe.contentWindow.print();
          // 6. 重置工作
          document.body.removeChild(iframe);

          container.removeAttribute("style");
        };
      }, 200);
    },
  },
};
</script>
<style>
#print {
  background: #1b1b1b;
}
</style>



// WEBPACK FOOTER //
// src/components/yanghuzuoyechaxun/dayin.vue